module.exports = __webpack_public_path__ + "img/greek-Unselected.73fc5f02.webp";